import type {
  CustomGroup,
  Filter,
  FilterDataOption,
  FiltersGroup,
  FiltersGroups,
} from '@/app/common/filters/core/filtersTypes.ts';

export function cloneFilterOptions(options: FilterDataOption[]) {
  return options.map((option: FilterDataOption) => ({
    ...option,
    labelComponent: option.labelComponent,
  }));
}

export function cloneFilters(filters: Filter[]) {
  return filters.map((filter: Filter) => {
    if ('options' in filter.data) {
      return {
        ...filter,
        data: {
          ...filter?.data,
          ...(filter?.data?.options ? { options: cloneFilterOptions(filter.data.options) } : {}),
        },
      };
    }

    return filter;
  });
}

export function cloneFiltersGroups(filtersGroups: FiltersGroups) {
  return filtersGroups.map((group: FiltersGroup | CustomGroup) => {
    if ('filters' in group) {
      return {
        ...group,
        ...(group?.filters ? { filters: cloneFilters(group?.filters) } : {}),
      } as FiltersGroup;
    }
    // CustomGroup or other
    return { ...group } as CustomGroup;
  });
}
